import {Component, OnInit} from '@angular/core';
import {HelpType} from "./help-type.enum";
import {UserRulesService} from "../user-rules/user-rules.service";
import {UserPrivacyService} from "../user-privacy/user-privacy.service";
import {UserCookiesService} from "../user-cookies/user-cookies.service";
import {BreadcumbsService} from "../breadcumbs/breadcumbs.service";
import {CommonService} from "../../common/common.service";
import {saveAs} from "file-saver";
import {NotificationType} from "../notifier/notification-type.enum";
import {NotifierService} from "../notifier/notifier.service";
import {JoyrideService} from "ngx-joyride";
import {UserReportsService} from "../user-reports/user-reports.service";
import {Router} from "@angular/router";
import {MoreLessPosition} from "./more-less-position.enum";

@Component({
  selector: 'pbc-user-help',
  templateUrl: './user-help.component.html',
  styleUrls: ["./user-help.component.scss"]

})
export class UserHelpComponent implements OnInit {

  helpType : HelpType = HelpType.Instruction;
  openSections : Array<number> =[];
  HelpTypeEnum = HelpType;

  MoreLessPositionEnum = MoreLessPosition;
  moreLessOpened : Array<MoreLessPosition> = [];

  constructor(
    private userRulesService : UserRulesService,
    private userPrivacyService : UserPrivacyService,
    private userCookiesService : UserCookiesService,
    private breadcumbsService: BreadcumbsService,
    private commonService : CommonService,
    private notifierService : NotifierService,
    private joyrideService : JoyrideService,
    private userReportsService : UserReportsService,
    private router: Router
  ) { }


  ngOnInit() {
    setTimeout(()=>this.breadcumbsService.setSubfolder.emit('Pomoc'),100);
  }

  helpTypeClick(helpType : HelpType) {
    this.helpType = helpType;
  }

  moreLessClick(moreLessPosition : MoreLessPosition) {
    let position = this.moreLessOpened.indexOf(moreLessPosition);
    if (position == -1)
      this.moreLessOpened.push(moreLessPosition);
    else
      this.moreLessOpened.splice(position, 1);
  }

  sectionOpenClose(sectionNumber : number) {
    let position = this.openSections.indexOf(sectionNumber);
    if (position==-1)
      this.openSections.push(sectionNumber);
    else
      this.openSections.splice(position, 1);
  }

  moveToHelpType(helpType : HelpType) {
    this.helpType = helpType;
  }

  showPrivacyClick() {
    this.userPrivacyService.showPrivacyRulesPopup(true);
  }
  showCookiesClick() {
    this.userCookiesService.showCookiesRules(true);
  }
  showRulesClick() {
    this.userRulesService.showUserRulesPopup(true);
  }

  getInstruction() {
    this.commonService.getInstruction().subscribe(
      data=> {
        saveAs(data, 'instrukcja użytkownika.pdf');
      },
      err => {
        console.log(err);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Nie można pobrać instrukcji użytkownika")
      }
    )
  }

  startTour(){
    const options = {
      steps: [
        'top-menu@user-reports/0/true',
        'reportDetails@user-reports/0/true',
        'getReport@user-reports/0/true',
        'shareAndSave@user-reports/0/true',
        'filtruj@user-reports/0/true',
        'searchBox@user-reports/0/true'
      ],
      stepDefaultPosition: 'bottom',
      themeColor: '#303030',
      showPrevButton: true,
      logsEnabled: false
    };
    this.joyrideService.startTour( options).subscribe(
      (step) => {
          this.userReportsService.setRefresh(false);
          this.userReportsService.setSelfTutorInProgress(true);
      },
      (error) => {
        console.log(error);
        this.router.navigate(['user-help']);
        this.userReportsService.setSelfTutorInProgress(false);
      },
      () => {
        this.router.navigate(['user-help']);
        this.userReportsService.setSelfTutorInProgress(false);
      }
    );
  }
}
